module.exports = __webpack_public_path__ + "static/media/background-toolshelf.379f26c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background-toolshelf.jpg
// module id = 961
// module chunks = 0